import React from "react";

export default function Summary() {
  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs-CT" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item"
              id="summary-tab"
              data-bs-toggle="tab"
              data-bs-target="#summary"
              type="button"
              role="tab"
              aria-controls="summary"
              aria-selected="true"
            >
              Summary
            </button>
          </li>
        </ul>

        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="summary"
            role="tabpanel"
            aria-labelledby="summary-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-3 pt-4">
                  <div className="table-responsive">
                    <table className="table table-striped mt-3">
                      <thead>
                        <tr>
                          <th style={{ textAlign: "center" }}>Sr. No</th>
                          <th style={{ textAlign: "center" }}>
                            Approved cases
                          </th>
                          <th style={{ textAlign: "center" }}>
                            Withdrawan cases
                          </th>
                          <th style={{ textAlign: "center" }}>
                            Limit assigned
                          </th>
                          <th style={{ textAlign: "center" }}>Limit used</th>
                        </tr>
                      </thead>
                      {/* <tbody>
                      {empDetails &&
                        empDetails.length > 0 &&
                        empDetails.map((detail, index) => (
                          <tr key={index}>
                            <td style={{ textAlign: "center" }}>{index + 1}</td>
                            <td style={{ textAlign: "center" }}>{detail.name}</td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                if (detail.lid) {
                                  setLid(detail.lid);
                                  setShowSearch(true);
                                }
                              }}
                            >
                              {detail.lid}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {detail.mobile}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {detail.limitassigned}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {detail.limitused}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {detail.status || "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <button
                                className="btn btn-success"
                                style={{ width: "100px" }}
                                onClick={() => {
                                  setShowModal(true);
                                  setLimitExtend(detail.limitassigned);
                                }}
                              >
                                Extend
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody> */}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
